import React, { Component, PropTypes } from 'react';
import Label from '../label/Label.jsx';
import CheckBox from '../checkbox/CheckBox.jsx';

export default class CheckBoxWithLabel extends Component {
	static propTypes = {
		handleChange: PropTypes.func.isRequired,
		id: PropTypes.string.isRequired,
		value: PropTypes.string,
		checked: PropTypes.bool.isRequired,
		label: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.object
		]).isRequired,
		labelIsInvisible: PropTypes.bool,
		labelDecoratorClass: PropTypes.string,
		wrapperClass: PropTypes.string,
		qaSelector: PropTypes.string
	};
	static defaultProps = {
		wrapperClass: ''
	};
	render() {
		const { id, wrapperClass } = this.props;

		return (
			<div className={`dna-form-field ${wrapperClass}`}>
				<CheckBox {...this.props} />
				<Label forAttr={id} {...this.props} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ../~/dna-form/components/checkbox-with-label/CheckBoxWithLabel.jsx